<template>
  <vue-good-table
    mode="remote"
    max-height="calc(100vh - 200px)"
    :total-rows="totalRecords"
    :columns="columns"
    :rows="projects"
    :pagination-options="{
      enabled: true,
      mode: 'pages',
      perPage,
      perPageDropdown: [100, 50],
      dropdownAllowAll: false,
      setCurrentPage: currentPage,
      nextLabel: 'ถัดไป',
      prevLabel: 'ก่อนหน้า',
      rowsPerPageLabel: 'จำนวนแถวต่อหน้า',
      ofLabel: 'จาก',
      pageLabel: 'หน้าที่', // for 'pages' mode
      allLabel: 'ทั้งหมด',
    }"
    :sort-options="{
      enabled: false
    }"
    @on-per-page-change="onPerPageChange"
    @on-page-change="onPageChange"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field === 'name'">
        <router-link :to="{ name: 'projects.show.proposal.basic', params: { id: props.row.id }}">{{ props.row.name }}</router-link>
      </span>
      <span v-else-if="props.column.field === 'amountRequested'">
        {{ props.row.funding.internal.osda + (props.row.funding.internal.approvedAdvance ? props.row.funding.internal.approvedAdvance : 0) | numeral("0,0.00") }}
      </span>
      <span v-else-if="props.column.field === 'check.amount'">
        <span v-if="props.row.check">
          {{ props.row.check.amount | numeral("0,0.00") }}
        </span>
        <span v-else>
          -
        </span>
      </span>
      <div v-else-if="props.column.field === 'statusText'">
        <span
          v-if="props.row.checkingStatus === 'Issued'"
          class="text-success"
        >
          <font-awesome-icon icon="check-circle" />ออกเช็คแล้ว
        </span>
        <span
          v-else-if="props.row.checkingStatus === 'Cancelled'"
          class="text-danger"
        >
          <font-awesome-icon icon="times-circle" />ยกเลิกเช็ค
        </span>
        <span
          v-else-if="!props.row.isCheckIssuingPossible"
          class="text-warning"
        >
          <font-awesome-icon icon="clock" />ค้างส่งประเมินฯ
        </span>
        <span v-else class="text-info">
          <font-awesome-icon icon="clock" />รอออกเช็ค
        </span>
      </div>
      <div v-else-if="props.column.field === 'action'">
        <b-button
          v-if="props.row.checkingStatus === 'Issued' || props.row.isCheckIssuingPossible || !props.row.isCheckIssuingPossible"
          size="sm"
          :variant="
            props.row.checkingStatus === 'Issued'
              ? 'outline-success'
              : 'success'
          " @click="showEditModal(props.row.id)"
        >
          {{
            props.row.checkingStatus === "Issued"
              ? "แสดงข้อมูลเช็ค"
              : "บันทึกข้อมูลเช็ค"
          }}
        </b-button>
        <b-button
          v-if="!props.row.check && !props.row.isCheckIssuingPossible"
          size="sm"
          variant="link"
          class="outline-danger"
          @click="showWaitingForClosureModal(props.row.id)"
        >
          ดูโครงการที่รอปิด
        </b-button>
      </div>
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
  </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      columns: [
        {
          label: 'ชื่อโครงการ',
          field: 'name'
        },
        {
          label: 'หน่วยงาน',
          field: 'group.name'
        },
        {
          label: 'จำนวนเงินที่ขออนุมัติ',
          field: 'amountRequested',
          thClass: 'text-center',
          tdClass: 'text-right'
        },
        {
          label: 'จำนวนเงินหน้าเช็ค',
          field: 'check.amount',
          thClass: 'text-center',
          tdClass: 'text-right'
        },
        {
          label: 'สถานะ',
          field: 'statusText',
          type: 'string',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'การกระทำ',
          field: 'action',
          type: 'string',
          thClass: 'text-center',
          tdClass: 'text-center'
        }
      ]
    }
  },
  computed: {
    projects () { return this.$store.getters['checking/getFilteredCheckingList'] },
    filters () { return this.$store.state.checking.filters },
    searchTerm () { return this.filters.search },
    perPage: {
      get () { return this.filters.perPage },
      set (value) { this.$store.commit('checking/setPerPageFilter', value) }
    },
    totalRecords () { return this.$store.state.checking.paginationInfo.total },
    currentPage: {
      get () { return this.$store.state.checking.paginationInfo.currentPage },
      set (value) { this.$store.commit('checking/setPageFilter', value) }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () { this.refetchTable() }
    }
  },
  methods: {
    showEditModal (projectId) {
      this.$emit('showEditModal', projectId)
    },
    showWaitingForClosureModal (projectPass) {
      this.$emit('showWaitingForClosureModal', projectPass)
    },
    refetchTable () {
      this.$store.dispatch('checking/fetchAllCheckingList')
    },
    onPerPageChange ({ currentPerPage }) { this.perPage = currentPerPage },
    onPageChange ({ currentPage }) { this.currentPage = currentPage }
  }
}
</script>

  <style scoped lang="scss">
.filters-bar {
  .filter {
    display: inline-block;
    margin: 0;
    padding: 0;
  }
}
</style>
